/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationForAzureKubernetesUserManagedOnboarded extends models.StorageConfigurationForAzureKubernetesUserManaged {
    constructor() {
        super();
        this.setDiscriminator("StorageConfigurationForAzureKubernetesUserManagedOnboarded");
    }

    getFixupPrototypeFunction() { return StorageConfigurationForAzureKubernetesUserManagedOnboarded.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationForAzureKubernetesUserManagedOnboarded>): StorageConfigurationForAzureKubernetesUserManagedOnboarded {
        let obj = Object.assign(new StorageConfigurationForAzureKubernetesUserManagedOnboarded(), model);
        StorageConfigurationForAzureKubernetesUserManagedOnboarded.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationForAzureKubernetesUserManagedOnboarded>): StorageConfigurationForAzureKubernetesUserManagedOnboarded {
        if (!model) return null;
        return StorageConfigurationForAzureKubernetesUserManagedOnboarded.newInstance(<StorageConfigurationForAzureKubernetesUserManagedOnboarded> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationForAzureKubernetesUserManagedOnboarded) {
        if (!obj) return;

        models.StorageConfigurationForAzureKubernetesUserManagedOnboarded.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationForAzureKubernetesUserManagedOnboarded): boolean {
        if (models.StorageConfigurationForAzureKubernetesUserManaged.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, StorageConfigurationForAzureKubernetesUserManagedOnboarded.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Reference to the linked Azure cloud account.
     */
    account_id: string;

}
